import NudosSpinnerLoader from './NudosSpinnerLoader';

export default NudosSpinnerLoader;
